import { FC } from 'react';
import { Card, Button, Icon, Banner } from '@servicetitan/design-system';
import * as Styles from './segment.module.less';
import classNames from 'classnames';
import { SmsCampaignRecurringServices as SmsCampaignRecurringServicesElem } from '../segment-parts/sms-campaign-recurring-services';
import { Customer as CustomerElem } from '../segment-parts/customer';
import { Location as LocationElem } from '../segment-parts/location';
import { isCustomFieldsSectionEmpty, isSectionEmpty, SegmentProps } from './segment';
import { AudienceFiltersSetType } from '@servicetitan/application-data/marketing';
import { Estimate as EstimateElem } from '../segment-parts/estimate';

interface SmsCampaignSegmentProps extends SegmentProps {
    error?: string | null | undefined;
    audienceType?: AudienceFiltersSetType;
}

export const SmsCampaignSegment: FC<SmsCampaignSegmentProps> = ({
    name,
    filters,
    qaPrefix,
    readonly,
    active,
    error,
    className,
    audienceType,
    CustomFieldsComponent,
    segmentId,
    locked,
    onSelect,
    onClose,
}) => {
    const {
        customer,
        customerCustomFields,
        recurringServices,
        estimate,
        location,
        locationCustomFields,
    } = filters;

    return (
        <Card
            onClick={readonly ? undefined : onSelect}
            className={classNames(Styles.segmentCard, className, `${qaPrefix}-segment`)}
            sharp
        >
            <Card.Section
                blue
                className={classNames(Styles.segmentCardTitle, active && Styles.active)}
            >
                <span>{name}</span>
                {locked && (
                    <Button
                        className={classNames(Styles.closeSegment, `${qaPrefix}-close-segment`)}
                    >
                        <Icon name="lock" />
                    </Button>
                )}
                {!readonly && (
                    <Button
                        className={classNames(Styles.closeSegment, `${qaPrefix}-close-segment`)}
                        onClick={onClose}
                        small
                    >
                        <Icon name="close" />
                    </Button>
                )}
            </Card.Section>
            {audienceType === AudienceFiltersSetType.RecurringServices && (
                <Card.Section className={Styles.segmentCardKpi}>
                    <SmsCampaignRecurringServicesElem
                        recurringEventDate={recurringServices?.recurringEventDate}
                        recurringEventDateRelative={recurringServices?.recurringEventDateRelative}
                        recurringEventStatus={recurringServices?.recurringEventStatus}
                        recurringServices={recurringServices?.recurringServices}
                        technicians={recurringServices?.technicians}
                    />
                </Card.Section>
            )}
            {audienceType === AudienceFiltersSetType.UnsoldEstimates && (
                <Card.Section className={Styles.segmentCardKpi}>
                    <EstimateElem estimate={estimate} />
                </Card.Section>
            )}
            {error && (
                <Card.Section>
                    <Banner status="critical" icon title={error} />
                </Card.Section>
            )}
            {((customer && !isSectionEmpty(customer)) ||
                !isCustomFieldsSectionEmpty(customerCustomFields?.filters)) && (
                <Card.Section className={Styles.segmentCardKpi}>
                    <CustomerElem
                        segmentId={segmentId}
                        customer={customer}
                        customFields={customerCustomFields}
                        CustomFieldsComponent={CustomFieldsComponent}
                    />
                </Card.Section>
            )}
            {((location && !isSectionEmpty(location)) ||
                !isCustomFieldsSectionEmpty(locationCustomFields?.filters)) && (
                <Card.Section className={Styles.segmentCardKpi}>
                    <LocationElem
                        segmentId={segmentId}
                        location={location}
                        customFields={locationCustomFields}
                        CustomFieldsComponent={CustomFieldsComponent}
                    />
                </Card.Section>
            )}
        </Card>
    );
};
